import { serialize, deserialize, getName } from './tools'
import Cookies from 'js-cookie'

export function getCookie(name: string) {
  const _value = Cookies.get(getName(name))
  if (!_value) return undefined
  return deserialize(_value)
}

export function setCookie(name: string, value: any, options?: Cookies.CookieAttributes) {
  const _value = serialize(value)
  Cookies.set(getName(name), _value, options)
}

export function removeCookie(name: string, options?: Cookies.CookieAttributes) {
  Cookies.remove(getName(name), options)
}
